<div class="row">
  <div class="col">
    <h3>{{ 'i18n.base.user-management.header' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex gap-2 align-items-center mb-2">
      <app-client-autocomplete (selectedClientChange)="onClientSelected($event)" [showSystem]="true"></app-client-autocomplete>
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <ejs-grid #grid
              class="grid-with-toolbar"
              width='100%'
              rowHeight='38'
              [dataSource]="data"
              [allowFiltering]='true'
              [filterSettings]='filterSettings'
              [allowSorting]='true'
              [pageSettings]='pageSettings'
              [allowPaging]='true'
              [editSettings]="editSettings"
              [searchSettings]="searchOptions"
              (actionComplete)="actionComplete($event)"
              (actionBegin)="actionBegin($event)">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
          <e-items>
            <e-item [text]="'i18n.base.user-management.buttons.add-web' | translate" prefixIcon='e-icons icon-add' (click)="addUser(false)"></e-item>
            <e-item [text]="'i18n.base.user-management.buttons.add-mobile' | translate" prefixIcon="e-icons icon-add" (click)="addUser(true)"></e-item>
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column headerText='id' field='userId' [visible]='false' [isPrimaryKey]='true'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.firstName' | translate" field="firstname" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.lastName' | translate" field="lastname" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.client' | translate" field="client.name" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.email' | translate" field="email" type="string" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.language' | translate" field="language" clipMode='EllipsisWithTooltip' [filter]="languageFilter"></e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.role' | translate" field="roles" clipMode='EllipsisWithTooltip' [filter]="roleFilter">
          <ng-template #filterItemTemplate let-data>{{formatRoles(data)}}</ng-template>
          <ng-template #template let-data>
            <span>{{formatRoles(data)}}</span>
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.base.user-management.column-headers.enabled' | translate" field="enabled" [visible]='showInactive' [filter]="isActiveFilter">
          <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'enabled')}}</ng-template>
          <ng-template #template let-data>
            @if(data.enabled) {
              <div class="e-icons icon-checkmark align-middle"></div>
            }
          </ng-template>
        </e-column>
        <e-column headerText="" [commands]='gridCommands' width='60px'></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
        <app-user-edit-form [userEditForm]="gridEditForm!"></app-user-edit-form>
      </ng-template>
    </ejs-grid>
  </div>
</div>
